import CaseStudyOneContainer from "./containers/CaseStudyOneContainer";
export default CaseStudyOneContainer;
